// biome-ignore lint/style/useFilenamingConvention: TanStack Router uses $param convention for dynamic routes
import { createRoute } from '@tanstack/react-router';
import { PurchaseOrderProductsPage } from '@/pages/purchase-orders/purchase-order-products-page';
import { Route as PurchaseOrderIdRoute } from './purchase-orders.$id';

export const Route = createRoute({
  getParentRoute: () => PurchaseOrderIdRoute,
  path: 'products',
  component: PurchaseOrderProductsPage,
});
